import React from 'react';

import TuringLogoText from '../../../assets/img/turing_logo_text.svg';
import GoogleLogo from '../../../assets/img/Google.svg';
import FacebookLogo from '../../../assets/img/Facebook.svg';
import TwitterLogo from '../../../assets/img/Twitter.svg';
import MicrosoftLogo from '../../../assets/img/Microsoft.svg';
// import AmazonLogo from '../../../../../assets/img/Amazon.svg';
import SnapIncLogo from '../../../assets/img/SnapInc.svg';
import TeslaLogo from '../../../assets/img/Tesla.svg';
import SpacexLogo from '../../../assets/img/Spacex.svg';
import TCLogo from '../../../assets/img/TC.svg';
import InformationLogo from '../../../assets/img/Information.svg';
import EntrepreneurLogo from '../../../assets/img/Entrepreneur.svg';
import ForbesLogo from '../../../assets/img/Forbes.svg';
import './rightSidebar.css';

const ExperienceComponent = () => {
  return (
    <div className="sidebar-container default-sidebar centered-ctn">
      <img className="turing-logo-text" src={TuringLogoText} alt="Turing" />
      <p className="turing-text title" style={{ width: '180px' }}>Work with the smartest engineers from all over the world</p>
      <p className="turing-text grey-text">We are backed by engineering executives and investors of </p>
      <div className="investors">
        <div className="logo-row">
          <img className="company-logo" src={GoogleLogo} alt="Google"/>
          <img className="company-logo facebook-logo" src={FacebookLogo} alt="Facebook"/>
          <img className="company-logo twitter-logo" src={TwitterLogo} alt="Twitter"/>
        </div>
        <div className="logo-row">
          <img className="company-logo" src={MicrosoftLogo} alt="Microsoft"/>
          {/* <img className="company-logo amazon-logo" src={AmazonLogo} alt="Amazon"/> */}
          <img className="company-logo" src={SnapIncLogo} alt="SnapInc"/>
        </div>
        <div className="logo-row">
          <img className="company-logo tesla-logo" src={TeslaLogo} alt="Tesla"/>
          <img className="company-logo spacex-logo" src={SpacexLogo} alt="Spacex"/>
        </div>
      </div>
      <div className="as-seen-on">
        <p className="light-grey-text">As seen on</p>
        <div className="logo-row">
          <img className="company-logo" src={TCLogo} alt="TC"/>
          <img className="company-logo" src={InformationLogo} alt="Information"/>
        </div>
        <div className="logo-row">
          <img className="company-logo" src={EntrepreneurLogo} alt="Entrepreneur"/>
          <img className="company-logo forbes-logo" src={ForbesLogo} alt="Forbes"/>
        </div>
      </div>
    </div>
  );
};

export default ExperienceComponent;
